import { render, staticRenderFns } from "./UploadQueueBar.vue?vue&type=template&id=2975d73c&scoped=true"
import script from "./UploadQueueBar.vue?vue&type=script&lang=ts"
export * from "./UploadQueueBar.vue?vue&type=script&lang=ts"
import style0 from "./UploadQueueBar.vue?vue&type=style&index=0&id=2975d73c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975d73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2975d73c')) {
      api.createRecord('2975d73c', component.options)
    } else {
      api.reload('2975d73c', component.options)
    }
    module.hot.accept("./UploadQueueBar.vue?vue&type=template&id=2975d73c&scoped=true", function () {
      api.rerender('2975d73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/UploadQueueBar.vue"
export default component.exports